// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"t5 pE","whiteTheme":"t6","markdownWrapper":"t7"};